import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import * as Icons from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { services } from '../../mock';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Reveal, Stagger, StaggerItem } from '../motion/Reveal';

export const ServicesGrid = () => {
  const { t } = useLanguage();
  return (
    <section className="py-24 bg-[#000000]">
      <div className="container mx-auto px-5 md:px-10">
        <Reveal className="text-center mb-16">
          <h2 className="heading-4 mb-4 gradient-text-primary">
            {t({ sl: 'NAŠE STORITVE', en: 'OUR SERVICES', it: 'I NOSTRI SERVIZI' })}
          </h2>
          <p className="body-medium text-[#b0b0b0] max-w-2xl mx-auto">
            {t({
              sl: 'Široka paleta tiskarskih storitev za vse vaše potrebe',
              en: 'Wide range of printing services for all your needs',
              it: 'Ampia gamma di servizi di stampa per tutte le vostre esigenze'
            })}
          </p>
        </Reveal>
        <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="home-services-grid">
          {services.slice(0, 6).map((service) => {
            const IconComponent = Icons[service.icon];
            return (
              <StaggerItem key={service.id} className="h-full">
                <Link to={`/services/${service.slug}`} className="block h-full">
                  <Card className="team-card bg-[#1a1a1a] border-[rgba(255, 255, 255, 0.1)] h-full cursor-pointer transition-all duration-300 hover:scale-[1.03]">
                    <CardHeader>
                      <div className="w-14 h-14 rounded-full bg-[white] flex items-center justify-center mb-4">
                        <IconComponent className="w-7 h-7 text-[#000000]" />
                      </div>
                      <CardTitle className="text-[white] text-lg">{t(service.title)}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <CardDescription className="text-[#b0b0b0]">{t(service.description)}</CardDescription>
                    </CardContent>
                  </Card>
                </Link>
              </StaggerItem>
            );
          })}
        </Stagger>
        <Reveal className="text-center mt-12" delay={0.1}>
          <Link to="/services">
            <Button className="btn-primary">
              {t({ sl: 'Poglej vse storitve', en: 'View All Services', it: 'Visualizza Tutti i Servizi' })}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
